import React from 'react';
import ProductCard from './ProductCard';

function ProductGrid({ items, onAddToCart, onUpdateQuantity, cart, onImageClick }) {
  return (
    <section className="product-grid">
      {items.map((item) => (
        <ProductCard 
          key={item.id} 
          product={item} 
          onAddToCart={onAddToCart} 
          onUpdateQuantity={onUpdateQuantity}
          cart={cart}
          onImageClick={onImageClick} 
        />
      ))}
    </section>
  );
}

export default ProductGrid;
